/// <amd-module name="Repos/Common/Util/ChangeType" />
import { VersionControlChangeType } from "Repos/Common/Contracts/Git";
import * as Resources from "Repos/Common/Resources";

const cachedChangeTypeTexts: { [changeType: number]: string } = {};

/**
 * Gets the display name of a given change type
 *
 * @param changeType Type of change to an item
 */
export function getChangeTypeDisplayName(changeType: VersionControlChangeType | undefined) {
    let changeTypeString = cachedChangeTypeTexts[changeType as number];
    if (typeof changeTypeString === "undefined") {
        if (changeType) {
            if (!changeType) {
                changeTypeString = Resources.ChangeTypeNone;
            } else {
                const pieces: string[] = [];
                if ((changeType & VersionControlChangeType.Merge) !== 0) {
                    pieces.push(Resources.ChangeTypeMerge);
                }

                if ((changeType & VersionControlChangeType.Add) !== 0) {
                    pieces.push(Resources.ChangeTypeAdd);
                }

                if ((changeType & VersionControlChangeType.Branch) !== 0) {
                    pieces.push(Resources.ChangeTypeBranch);
                }

                if ((changeType & VersionControlChangeType.Delete) !== 0) {
                    pieces.push(Resources.ChangeTypeDelete);
                }

                if (
                    (changeType & VersionControlChangeType.Encoding) !== 0 &&
                    !((changeType & VersionControlChangeType.Branch) !== 0) &&
                    !((changeType & VersionControlChangeType.Add) !== 0)
                ) {
                    pieces.push(Resources.ChangeTypeFileType);
                }

                if ((changeType & VersionControlChangeType.Lock) !== 0) {
                    pieces.push(Resources.ChangeTypeLock);
                }

                if ((changeType & VersionControlChangeType.Rename) !== 0) {
                    pieces.push(Resources.ChangeTypeRename);
                }

                if ((changeType & VersionControlChangeType.Undelete) !== 0) {
                    pieces.push(Resources.ChangeTypeUndelete);
                }

                if ((changeType & VersionControlChangeType.Edit) !== 0 && !((changeType & VersionControlChangeType.Add) !== 0)) {
                    pieces.push(Resources.ChangeTypeEdit);
                }

                if ((changeType & VersionControlChangeType.Rollback) !== 0) {
                    pieces.push(Resources.ChangeTypeRollback);
                }

                if ((changeType & VersionControlChangeType.SourceRename) !== 0) {
                    pieces.push(Resources.ChangeTypeSourceRename);
                }

                if ((changeType & VersionControlChangeType.Property) !== 0) {
                    pieces.push(Resources.ChangeTypeProperty);
                }

                changeTypeString = pieces.join(", ");
            }

            cachedChangeTypeTexts[changeType as number] = changeTypeString;
        }
    }
    return changeTypeString;
}

export function getDecorationText(changeType: VersionControlChangeType, usePlusSignForAdds: boolean) {
    let changeTypeText = "";

    if ((changeType & VersionControlChangeType.Add) === VersionControlChangeType.Add && usePlusSignForAdds) {
        // only Add
        changeTypeText = "+";
    } else if (changeType === VersionControlChangeType.Edit) {
        // only Edit
        changeTypeText = "";
    } else if (changeType === VersionControlChangeType.Delete) {
        // only Delete
        changeTypeText = "";
    } else if (changeType === VersionControlChangeType.Merge) {
        // only Merge
        changeTypeText = Resources.ChangeTypeMerge;
    } else if (changeType === VersionControlChangeType.Branch) {
        // only Branch
        changeTypeText = Resources.ChangeTypeBranch;
    } else if (changeType === VersionControlChangeType.Undelete) {
        // only Undelete
        changeTypeText = Resources.ChangeTypeUndelete;
    } else if (changeType === VersionControlChangeType.Rollback) {
        // only Rollback
        changeTypeText = Resources.ChangeTypeRollback;
    } else if (changeType === VersionControlChangeType.Encoding) {
        // only Encoding
        changeTypeText = Resources.ChangeTypeFileType;
    } else if ((changeType & VersionControlChangeType.Branch) === VersionControlChangeType.Branch) {
        // for Branch, ignore Edit and Encoding
        changeTypeText = getChangeTypeDisplayName(changeType);
    } else {
        changeTypeText = getChangeTypeDisplayName(changeType);
    }

    return changeTypeText;
}
